<template>
  <section class="web-container">
    <div class="zhu-ti">
      <div class="bian-xin">
        <div class="nav-title">
          <div class="left">
            <div class="logo">
              <img style="width: 130px;" src="./image/log.png" alt="">
              <!-- <div class="yuan"></div> -->
            </div>
            <!-- <div class="text">WDP</div> -->
          </div>
          <div class="zhong">
            <div class="list-nav">
              <a style="color: #0099f7;" href="#sy" id="Home">Home</a>
            </div>
            <!-- <div class="list-nav">
              <a id="Whitelist">Whitelist</a>
            </div>
            <div class="list-nav">
              <a href="">Website builder</a>
            </div> -->
            <div class="xia">
              <span>More</span>
              <img src="./image/jiantou.png" alt="arrowhead">
              <div class="xia-la">
                <div class="list" @click="open('https://t.me/wdpapperc20portal')">
                  <img src="./image/t5 (2).png" alt="">
                  <div class="text">Telegram</div>
                </div>
                <div class="list" @click="open('https://twitter.com/WDPAIGAMING')">
                  <img src="./image/t5 (1).png" alt="">
                  <div class="text">Twitter</div>
                </div>
                <div class="list" @click="open('https://docs.wdp.app')">
                  <img src="./image/t5 (3).png" alt="">
                  <div class="text">whitepaper</div>
                </div>
              </div>
            </div>


          </div>
          <!-- <img style="width:20px;height:20px" src="./image/t4.png" alt=""> -->
          <!-- <div class="right">
            <div class="btn">Wallet</div>
          </div> -->
        </div>
        <div id="box1">
          <div class="s-y" id="sy">
            <div class="left">

              <div class="text">
                <div class="line" style="
  font-size: 64px;
  text-align: center;
  font-family: Galano Grotesque Alt DEMO-Bold, Galano Grotesque Alt DEMO;">
                All-New WEB3 AI Gaming Platform
                </div>
                <div style="
  font-size: 30px;
  font-weight: 400;
  color: #D1D1D1;
  margin-top: 35px;
  text-align: center;
  font-family: PingFang SC-Regular, PingFang SC;">PLAY WITH AI TO EARN</div>
              </div>
              <div class="title">
                <img style="width: 692px;
  height: 488px;" src="./image/1.png" alt="">

              </div>
              <div class="btn-all">

                <div @click="open('https://app.wdp.app')" class="btn1 btn">
              
                  
             Start

                </div>
                <div class="btn3 btn" @click="open('https://docs.wdp.app/')">
                  <div class="btn2 ">
                    MORE
                  </div>
                </div>

              </div>
            </div>

          </div>

          <div class="trade" id="trade">
            <div class="left">
              <img src="./image/7.png" alt="">
            </div>
            <div class="right">
              <div class="title">
                <span style="color:#5780FF;font-family: Galano Grotesque Alt DEMO-Bold, Galano Grotesque Alt DEMO;
  font-size: 50px;">Compete against AI in games and earn money. Games include Pac-Man, Connect, and Tetris. Learn more.</span>
              </div>
              <div class="text">
                <div class="list">
                  <img src="./image/15.png" alt="">Pacman
                </div>
                <div class="list">
                  <img src="./image/15.png" alt="">Snake
                </div>
                <div class="list">
                  <img src="./image/15.png" alt="">Tetris
                </div>
              </div>
              <div class="btn" @click="open('https://app.wdp.app')">
                Start
              </div>
            </div>
          </div>
          <div class="s-y2" id="s-y2-1" style="
  background: rgba(84, 115, 206, 0.112);margin-top: 0px;
  backdrop-filter: blur(10px);
  ">

            <div class="left" style=" width: 100%;">

              <div class="text">
                <div class="line" style="
  font-size: 72px;
  text-align: center;
  
  font-family: Galano Grotesque Alt DEMO-Bold, Galano Grotesque Alt DEMO;
  font-weight: bold;
  color: #fff;
  ">
              One-Stop WEB3 AI Gaming  <span style="color: #5780FF;">Platform</span>

                </div>
                <div style="
  font-size: 30px;
  font-weight: 400;
  color: #D1D1D1;
  margin-top: 35px;
  text-align: center;
  font-family: PingFang SC-Regular, PingFang SC;">Play games with AI, make games with AI, promote games with AI, and make money from all these activities!</div>
              </div>
              <div class="center-box">

                <div class="box">
                  <img src="./image/8.png" alt="">
                  <div class="text1" style="text-align: center;">Earn Money by Playing Games with AI </div>
                  <div class="text2">Connect your wallet, start competing in games against AI, and earn money!</div>

                  <div class="pai">NO.1</div>

                </div>
                <div class="box">
                  <img src="./image/9.png" alt="">
                  <div class="text1" style="text-align: center;">Create and Publish Your Game Using AI</div>
                  <div class="text2">Use AI to create and publish games on the platform and enjoy high commission returns.</div>

                  <div class="pai">NO.2</div>

                </div>
                <div class="box">
                  <img src="./image/10.png" alt="">
                  <div class="text1" style="text-align: center;">Utilize AI-Powered Marketing Assistant to Generate Personal Invitation Links</div>
                  <div class="text2">Invite friends to play games together and earn commission.</div>

                  <div class="pai">NO.3</div>

                </div>
              </div>

            </div>

          </div>

          <div class="earn" id="earn">
            <div class="left">
              <div class="title">
                AI + Gaming: A New Model Changing Traditional Games. Experience the Brand New AI GAME-FI.
              </div>
              <div class="text">
              The platform combines AI technology with game development techniques to create a brand-new AI gaming platform. By introducing AI technology into the WEB3 gaming domain, AI GAME-FI is set to represent the future of the gaming industry.
              </div>

            </div>
            <div class="right">
              <img src="./image/11.png" alt="">
            </div>
          </div>



          <div class="line" style="
  font-size: 72px;
  text-align: center;
  margin-bottom: 57px;
  
  font-family: Galano Grotesque Alt DEMO-Bold, Galano Grotesque Alt DEMO;
  font-weight: bold;
  color: #fff;
  ">
            Roadmap

          </div>
           <div class="step" >
  <div style="
  font-size: 40px;
  text-align: center;
  margin-bottom: 20px;
  
  font-family: Galano Grotesque Alt DEMO-Bold, Galano Grotesque Alt DEMO;
  font-weight: bold;
  color: #fff;
  ">
    Phase 1

  </div>
          <div class="step-box">

            <Steps
:stepInfo="stepInfo"
   />
   <div class="leftall"></div>

          </div>

        </div>

           <div class="step" >
  <div style="
  font-size: 40px;
  text-align: center;
  margin-bottom: 20px;
  
  font-family: Galano Grotesque Alt DEMO-Bold, Galano Grotesque Alt DEMO;
  font-weight: bold;
  color: #fff;
  ">
    Phase 2

  </div>
          <div class="step-box">

            <Steps
:stepInfo="stepInfo2"
   />

   <div class="leftall"></div>
          </div>

        </div>
  
           <div class="step" >
  <div style="
  font-size: 40px;
  text-align: center;
  margin-bottom: 20px;
  
  font-family: Galano Grotesque Alt DEMO-Bold, Galano Grotesque Alt DEMO;
  font-weight: bold;
  color: #fff;
  ">
    Phase 3

  </div>
          <div class="step-box">

            <Steps
:stepInfo="stepInfo3"
   />
   <div class="leftall"></div>

          </div>

        </div>


          <div class="line" style="
  font-size: 72px;
  text-align: center;
  margin-bottom: 107px;
  
  font-family: Galano Grotesque Alt DEMO-Bold, Galano Grotesque Alt DEMO;
  font-weight: bold;
  color: #fff;
  ">
            Our <span style="color: #5780FF;">partner</span>

          </div>
          <div class="money">

            <div class="list">
              <img src="./image/2.png" alt="">
              <div class="title">Gate</div>

            </div>
            <div class="list">
              <img style="" src="./image/3.png" alt="">
              <div class="title">OKX</div>

            </div>
            <div class="list">
              <img src="./image/4.png" alt="">
              <div class="title">MECK</div>

            </div>
            <div class="list">
              <img src="./image/5.png" alt="">
              <div class="title">TokenPocket</div>

            </div>
            <div class="list">
              <img src="./image/6.png" alt="">
              <div class="title">Lemond</div>

            </div>
          </div>

          <div class="line" style="
  font-size: 72px;
  text-align: center;
  margin-bottom: 107px;
  
  font-family: Galano Grotesque Alt DEMO-Bold, Galano Grotesque Alt DEMO;
  font-weight: bold;
  color: #fff;
  ">
           play to <span style="color: #5780FF;">earn</span>

          </div>
          <div class="classbox" id="classbox">

            <div class="botton1" @click="open('https://t.me/wdpapperc20portal')">
              <img style="width: 32px;
  height: 32px;margin-right: 5px;" src="./image/t1.png" alt="">
              Telegram
            </div>
            <div class="botton1" @click="open('https://twitter.com/WDPAIGAMING')">
              <img style="width: 32px;
  height: 32px;margin-right: 5px;" src="./image/t2.png" alt="">
              Twitter
            </div>
            <div class="botton1" @click="open('https://docs.wdp.app')">
              <img style="width: 32px;
  height: 32px;margin-right: 5px;" src="./image/t3.png" alt="">
   
   whitepaper
            </div>



          </div>
          <p class="emal">E-mail：Chavez@wdp.app</p>

        </div>



        <!-- <div class="s-y3" id="s-y2" id="box2" style="
       margin-top: 0px;
            ">
          
                          <div class="left" style=" width: 100%;">
          
                              <div class="text">
                                  <div class="line" style="
            font-size: 48px;
            text-align: center;
            
            font-family: Galano Grotesque Alt DEMO-Bold, Galano Grotesque Alt DEMO;
            font-weight: bold;
            color: #fff;
            ">
                                 Get ready to launch your token
          
                                  </div>
                                  <div style="
            font-size: 24px;
            font-weight: 400;
            color: #D1D1D1;
            margin-top: 35px;
            text-align: center;
            font-family: PingFang SC-Regular, PingFang SC;">create，manage and launch your token</div>
                              </div>
                              <div class="center-box">
          
                                  <div class="box">
                                      <img src="./image/16.png" alt="">
                                      <div class="text1">Register your account</div>
                                      <div class="text2">The wallet youˋve connected is the 
                                        owner of your token</div>
          
                                      <img class="pai" src="./image/19.png" alt="">
                                      <div class="btn-all">

                                        <div class="btn1 btn">
                                            Edit profile
                                        </div>
                                    
                
                                    </div>
                                  </div>
                                  <div class="box">
                                      <img src="./image/17.png" alt="">
                                      <div class="text1">Create your account</div>
                                      <div class="text2">Get everything set up and prepared 
                                        for launch day</div>
          
                                        <img class="pai" src="./image/19.png" alt="">
                                        <div class="btn-all">

                                            <div class="btn1 btn">
                                                Edit profile
                                            </div>
                                       
                    
                                        </div>
                                  </div>
                                  <div class="box">
                                      <img src="./image/18.png" alt="">
                                      <div class="text1">Make your website</div>
                                      <div class="text2">Build afully customizable website
                                        -its fast&freel</div>
          
                                        <div class="btn-all">
                                            <div class="btn3 btn">
                                                <div class="btn2 ">
                                                    Go
                                                </div>
                                            </div>
                    
                                        </div>
                                  </div>
                              </div>
          
                          </div>
          
                      </div> -->

      </div>
    </div>
  </section>
</template>

<script>

import Steps from '@/components/steps/index.vue'

export default {
  components:{
    Steps
  },
  
data () {
    return {
      stepInfo: {
					list: [{
							name: 'Game Developement'
						},
						{
							name: 'Whitepaper'
						},
						{
							name: 'Contract creation'
						},
            {
							name: 'Marketing & Community building'
						},
            {
							name: 'Pinksale Launch'
						},
					],

                   //步骤条进度
					step: 2
				},
      stepInfo2: {
					list: [{
							name: 'More Games intergration '
						},
						{
							name: 'AI-Powered Marketing Assistant'
						},
						{
							name: 'CEX Listing'
						},
            {
							name: 'Auditing'
						},
            {
							name: 'Partnership expansion'
						},
					],
          
                   //步骤条进度
					step: 2
				},
        stepInfo3: {
					list: [{
							name: 'Game Developement  Assistant'
						},
						{
							name: 'NFT Listing'
						},
						{
							name: 'Expanding the Team'
						},
            {
							name: 'Participation in Summits'
						},
           
					],
          
                   //步骤条进度
					step: 2
				},
    }
},



  methods:{
    open(url){
      window.location.href=url
    }
  },
};
</script>

<style lang="less" scoped>
.step{
  padding: 0 5%;
  margin-bottom: 100px;
}
.step-box{
  position: relative;
  display: flex;
  align-items: center;
height: 279px;
background: rgba(84,114,206,0.2);
border-radius: 24px 24px 24px 24px;
opacity: 1;
padding: 20px;
border: 1px solid #5472CE;

.leftall{
  width: 4px;
height: 200px;
background: #5780FF;
border-radius: 24px 24px 24px 24px;
opacity: 1;
position: absolute;
left: 0;
top: 35px;
}
}
.web-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.el-aside {
  width: 326px;
  height: 100vh;
  background-color: #1a1f1b;
  border-right: 1px solid #818181;
}

.el-header {
  background-color: #021005;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  height: 140px !important;
  padding-top: 40px;
  padding-right: 48px;

  .connect {
    display: inline-block;
    width: 211px;
    height: 55px;
    background-size: 100% 100%;
    margin-right: 20px;
    cursor: pointer;
  }

  .tip {
    display: inline-block;
    width: 30px;
    height: 30px;
    background-size: 100% 100%;
    margin-right: 20px;
    cursor: pointer;
  }

  .case {
    display: inline-block;
    width: 30px;
    height: 30px;
    background-size: 100% 100%;
    cursor: pointer;
  }
}

.main-container {
  height: 100vh;
  background-color: #021005;
}


.page-main {
  overflow: auto;
}

/deep/.el-main {
  padding: 0;
}
</style>